import React from 'react';
import twMerge from 'utilities/src/twMerge';

interface Props {
  isDark: boolean;
  classes?: string;
}

export default function GradientCorner({ isDark, classes }: Props) {
  return (
    <div
      className={twMerge(
        'to-site-neutrals-25 mdL:block duration-50 absolute left-0 hidden h-full w-5 -translate-x-full bg-gradient-to-r from-transparent transition-opacity duration-300',
        { 'to-site-neutrals-900': isDark },
        classes,
      )}
    />
  );
}
